import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';


import {ImageOverlayService} from './image-overlay.service';
import {MatSlider} from '@angular/material/slider';
import {MatDialogRef} from '@angular/material/dialog';
import {MatCheckboxChange} from '@angular/material/checkbox';

@Component({
    selector: 'burncase-image-overlay',
    templateUrl: './image-overlay.component.html',
    styleUrls: ['./image-overlay.component.css']
})
export class ImageOverlayComponent implements OnInit {

    @ViewChild('slider', {static: true}) slider: ElementRef<MatSlider>;
    public checked: boolean;

    constructor(public dialogRef: MatDialogRef<ImageOverlayComponent>,
                public imageOverlayService: ImageOverlayService) {
        this.checked = this.imageOverlayService.move;
    }

    /**
     * removes or adds landmarks from/to scene
     */
    public changeLandmarkVisibility(event: MatCheckboxChange) {
        this.imageOverlayService.landmarksVisible = event.checked;
    }

    ngOnInit() {

    }


}
